$(document).ready(function() {
	
	var KEY_ENTER          = 13;
	var KEY_BACKSPACE      = 8;
	
	//pak de length van filter en personal tags om later te kijken of ze zijn veranderd
	var personalTagsLength = 0;
	var filterTagsLength   = 0;
	
	$(document).on('change', ".checkCatTag", function() {
		var tag = $("label[for='"+$(this).attr('id')+"']").html();
		var checked = $(this).is(':not(:checked)');
		
		var found = false;
		$("#tag input[type='hidden']").each(function () {
			if ($(this).val().toLowerCase().trim() == tag.toLowerCase().trim() && checked) {
				$(this).siblings('.remove').click();
				found = true;
			} 
		});
		if (!found && !checked) {
			$('#tag > input').val(tag+','+$('#tag > input').val());
			$('#tag > input').attr('placeholder','');
		}
		$('#tag > input').keyup();
		insertFilterTags();
	});
	
	//personal tags
	$(document).on('change', ".checkCatTagPersonal", function() {
		var tag = $("label.removeTagLabelPersonal[for='"+$(this).attr('id')+"']").html();
		var checked = $(this).is(':not(:checked)');
		
		var found = false;
		$("#tagPersonal input[type='hidden']").each(function () {
			if ($(this).val().toLowerCase().trim() == tag.toLowerCase().trim() && checked) {
				$(this).siblings('.remove').click();
				found = true;
			} 
		});
		if (!found && !checked) {
			$('#tagPersonal > input').val(tag+','+$('#tagPersonal > input').val());
			$('#tagPersonal > input').attr('placeholder','');

		}
		$('#tagPersonal > input').keyup();
		insertPersonalTags();
	});
	
	//backspace of enter bij invoer
	$(document).on('keyup', '.tags_personal > input', function(event) {
		if (event.which === KEY_ENTER || event.which === KEY_BACKSPACE) {
			insertPersonalTags();
		}
	});
	
	//kijk of je op een autocomplete result heb geklikt
	$(document).on('mousedown', '.acResults', function(e) {
		//aleen kijken als menu open is
		if ($('.menuOn').length > 0) {
			//personal tags
			countPersonalTags = $('#tagPersonal > div').length;
			if (countPersonalTags != personalTagsLength) {
				
				personalTagsLength = countPersonalTags;
				insertPersonalTags();
			}
			
			//filter tags
			countFilterTags = $('#tag > div').length;
			if (countFilterTags != filterTagsLength) {
				
				filterTagsLength = countFilterTags;
				insertFilterTags();
		
			}
			
		}
	});
	
	//backspace of enter bij invoer
	$(document).on('keyup', '.tags > input', function(event) {
		if (event.which === KEY_ENTER || event.which === KEY_BACKSPACE) {
			insertFilterTags();
		}
	});
	
	
	//prevent tagforms on enter keydown from submitting
	$(document).on('keydown', '.tags_personal > input', function(event) {
		if (event.which === KEY_ENTER) {
			event.preventDefault();
		}
	});
	
	$(document).on('keydown', '.tags > input', function(event) {
		if (event.which === KEY_ENTER) {
			event.preventDefault();
		}
	});


	var prevHeight = $("#weather_header_icon img").height();
	//Vergroot weericoon bovenin
	$("#weather_header_icon img").mouseenter(function() {
		var height     = this.naturalHeight;
	    $(this).stop().animate({ "height": height}, "slow");

	}).mouseleave(function() {
		//Reset the image
		$(this).stop().animate({ "height": prevHeight}, "slow");
	});
	$(document).on('click','.csp_saveTags',function(event) {
		showRemoveAllTags($(this).data('savedTags'));
	});
	$(document).on('click','.csp_removeTags',function(event) {
		removePersonalTag($(this).data('remove'));
	});
});

//Rename tags
var renameTag = [];
renameTag["- (triest nieuws)"] = "-";

function insertPersonalTags() {

	var tags = [];
	$('.quickPersonalLinks').remove();
	$('.quickShortLinks').remove();

	var shortTags = [];
	$('.shortLinks').each(function() {
		shortTags.push($(this).html().toLowerCase()); //'belangrijk','vandaag','gisteren','eergisteren'
	});

	//Eerst de checkbox afhandelen
	
	// blue tags
	var selected = [];
	$('.checkCatTagPersonal:checked').each(function() {
		selected.push($(this).val());

		labelName = $(this).next('label').html();
		
		// belangrijk, vandaag, gisteren, eergisteren need a time period.
		// ii and Nederland are suposed to have a time period too but that leads to empty pages often. Besides,
		// the items are already ordered from newest to oldest.
		if ($.inArray(labelName.toLowerCase(), shortTags) > -1) {
			var url = fetchLinkPersonalTags(labelName);
			// add
			$('.quickLinks').append("\n<a class='quickShortLinks' href='"+url+"'>"+labelName+"</a>\n");
		}
	});

	// orange tags
	$('[name=tagPersonal\\[\\]]').each(function() {

		//Rename tag
		var tagNameInURL = setUrlNametag(renameTag, $(this).val().trim());
		var key = setKeyNametag(renameTag,tagNameInURL);
		
		$('a.cloud_personal_tag[href="index?tag='+tagNameInURL+'"]').html(key);

		tags.push(tagNameInURL);

		//Blauwe tags van de oranje onderscheiden
		if ($.inArray(tagNameInURL.toLowerCase(), shortTags) == -1) {
			$('.quickLinks').append("\n<a class='quickPersonalLinks' href='?tag="+tagNameInURL+"'>"+tagNameInURL+"</a>\n");
		}
	});

	//Add copytags
	addCopyTag();

	return $.ajax({
		type: 'POST',
		url: '/ajax/insert_tags.php',
		data: { tags: tags, selected: selected, mode: 'personal'}
	});
}

// date in format 'year-month-day'
// IN: date object
//UIT: string
function formatDate(dateObject) {
	month = dateObject.getUTCMonth() + 1; //months from 1-12
	day = dateObject.getUTCDate();
	year = dateObject.getUTCFullYear();
	date = year + "-" + month + "-" + day;
	return date;
}


function insertFilterTags() {
	var tags = [];
	$('[name=tag\\[\\]]').each(function() {

		//Rename tag
		url = setUrlNametag(renameTag, $(this).val().trim());
		key = setKeyNametag(renameTag,url);

		$('a.tag_item[href="index?tag='+url+'"]').html(key);

		tags.push(url);

	});

	//Add copytags
	addCopyTag();

	var selected = [];
	$('.checkCatTag:checked').each(function() {
		selected.push($(this).val());
	});
	
	return $.ajax({
		type: 'POST',
		url: '/ajax/insert_tags.php',
		data: { tags: tags, selected: selected, mode: 'filter'}
	});

}

//Voeg copyTag toe als filter en personaltag gelijk zijn
function addCopyTag() {
	var filterTags = [];
	$('[name=tag\\[\\]]').each(function() {

		url = setUrlNametag(renameTag, $(this).val().trim());
		key = setKeyNametag(renameTag,url);

		filterTags.push(key);
	});


	var personalTags = [];
	$('[name=tagPersonal\\[\\]]').each(function() {

		url = setUrlNametag(renameTag, $(this).val().trim());
		key = setKeyNametag(renameTag,url);

		$('a.tag_item[href="index?tag='+key+'"]').attr("href", "index?tag="+url);
		$('a.cloud_personal_tag[href="index?tag='+key+'"]').attr("href", "index?tag="+url);
		
		personalTags.push(key);

		//Remove copyTag
		$('a.quickPersonalLinks[href="?tag='+url+'"]').removeClass('copyTag');

		//Add copyTag if in both personal and filtertags
		if ($.inArray(key, filterTags) > -1) {
			$('a.quickPersonalLinks[href="?tag='+url+'"]').remove();
			$('.quickLinks').append("<a class='quickPersonalLinks copyTag' href='?tag="+url+"'>"+url+"</a>\n");
			//$('a.quickPersonalLinks[href="?tag='+url+'"]').addClass('copyTag');
		}
	});
}



//Zoekt de vervangende naam bij de gegeven tag
//IN: renameTag - de renameTag array waarin alle vervangingen staan
//    url       - De te checken tag
//OUT: Als gevonden: De key van de array, als niet gevonden: de tag zelf
function setKeyNametag(renameTag,url) {
	//Weergeef juiste tekst BV: '- (triest nieuws)''
	temp = arraySearch(renameTag, url);
	if (temp !== false) {
		return temp;
	}
	return url;
}


//Zoekt de vervangende naam bij de gegeven tag, zodat deze in de url goed komt te staan
//IN: renameTag - de renameTag array waarin alle vervangingen staan
//    url       - De te checken tag
//OUT: Als gevonden: De url van de array, als niet gevonden: de tag zelf
function setUrlNametag(renameTag, url) {
	//Weergeef juiste tekst voor url BV: '-'
	if( renameTag[url] !== undefined ) {
		return renameTag[url];
	}
	return url;
}


//Zoekt de key bij de value van een array:
//VB: Array : hoi['key'] = 'value';
//    key = arraySearch(hoi,'value');
//IN: arr - array
//    val - value
//OUT: key behorend bij value
function arraySearch(arr,val) {
	for (var key in arr) {
		if (arr[key] === val) {              
			return key;
		}
	}
	return false;
}


function toggleColumnShow() {
	if ($('#toggleColumnShowLink').html() == 'kolommen') {
		$('.columndisplay').show();
		$('#toggleColumnShowLink').html('x');
	} else {
		$('.columndisplay').hide();
		$('#toggleColumnShowLink').html('kolommen');
	}
	return false;
}

function showFilterForm() {
	if ($('.filter_tag').hasClass('filter_form_open')) {
		$('#filterTagForm fieldset').slideUp();
		$('.tags .remove').hide();
		$('.tags .acInput').hide();
		$('.filter_tag').removeClass('filter_form_open');
	} else {
		$('#filterTagForm fieldset').slideDown();
		$('.tags .remove').show();
		$('.tags .acInput').show();
		$('.filter_tag').addClass('filter_form_open');
	}
	
}

function showFilterFormPersonal(){
	if ($('.personal_tag_form').hasClass('filter_form_open')) {
		$('#personalTagForm fieldset').slideUp();
		$('.tags_personal .acInput').hide();
		$('.tags_personal .remove').hide();
		$('.personal_tag_form').removeClass('filter_form_open');
	} else {
		$('#personalTagForm fieldset').slideDown();
		$('.tags_personal .acInput').show();
		$('.tags_personal .remove').show();
		$('.personal_tag_form').addClass('filter_form_open');
	}
	
}
// -----IDD-MINIFY-SETTINGS
// ecmaVersion:11
// -----IDD-MINIFY-SETTINGS-DONE
